import { Search, ExternalLink } from 'lucide-react'

interface ResearchCardProps {
  data: Record<string, unknown>
}

function extractHostname(url: string): string {
  try {
    return new URL(url).hostname.replace(/^www\./, '')
  } catch {
    return url
  }
}

export function ResearchCard({ data }: ResearchCardProps) {
  const sources = Array.isArray(data.sources) ? (data.sources as string[]) : []
  const count =
    typeof data.source_count === 'number' ? data.source_count : sources.length

  return (
    <div className="rounded-xl border border-slate-100 bg-white shadow-sm p-4">
      <div className="flex items-center gap-2 mb-3">
        <div className="flex items-center justify-center w-7 h-7 rounded-lg bg-blue-50 text-blue-600">
          <Search className="w-3.5 h-3.5" />
        </div>
        <span className="text-xs font-semibold text-slate-600 uppercase tracking-wide">
          Investigacion
        </span>
        <span className="ml-auto text-xs font-medium text-blue-600 bg-blue-50 px-2 py-0.5 rounded-full">
          {count} {count === 1 ? 'fuente' : 'fuentes'}
        </span>
      </div>

      {sources.length > 0 ? (
        <ul className="space-y-1.5">
          {sources.map((url, i) => (
            <li key={i} className="flex items-center gap-2 min-w-0">
              <img
                src={`https://www.google.com/s2/favicons?domain=${extractHostname(url)}&sz=16`}
                alt=""
                className="w-3.5 h-3.5 shrink-0 rounded-sm"
                onError={(e) => {
                  ;(e.target as HTMLImageElement).style.display = 'none'
                }}
              />
              <a
                href={url}
                target="_blank"
                rel="noopener noreferrer"
                className="text-xs text-slate-500 hover:text-blue-600 truncate flex-1 flex items-center gap-1"
              >
                <span className="truncate">{extractHostname(url)}</span>
                <ExternalLink className="w-2.5 h-2.5 shrink-0 opacity-50" />
              </a>
            </li>
          ))}
        </ul>
      ) : (
        <p className="text-xs text-slate-400">Fuentes procesadas</p>
      )}
    </div>
  )
}
